import React from 'react';
import PhonicsAtoZ from './PhonicsAtoZ';
import letterDataSs from './phonics/phonics_data_ss';

function PhonicsSs() {
  return <PhonicsAtoZ letterData={letterDataSs} />;
}

export default PhonicsSs;
